import { render, staticRenderFns } from "./PxCriterioProduto.vue?vue&type=template&id=05356c24&"
import script from "./PxCriterioProduto.vue?vue&type=script&lang=js&"
export * from "./PxCriterioProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports